const ClientTypes = {
  GET_CLIENT_LIST_REQUEST: 'GET_CLIENT_LIST_REQUEST',
  GET_CLIENT_LIST_SUCCESS: 'GET_CLIENT_LIST_SUCCESS',
  GET_CLIENT_LIST_ERROR: 'GET_CLIENT_LIST_ERROR',

  ADD_CLIENT_REQUEST: 'ADD_CLIENT_REQUEST',
  ADD_CLIENT_SUCCESS: 'ADD_CLIENT_SUCCESS',
  ADD_CLIENT_ERROR: 'ADD_CLIENT_ERROR',

  GET_CLIENT_ITEM_REQUEST: 'GET_CLIENT_ITEM_REQUEST',
  GET_CLIENT_ITEM_SUCCESS: 'GET_CLIENT_ITEM_SUCCESS',
  GET_CLIENT_ITEM_ERROR: 'GET_CLIENT_ITEM_ERROR',

  UPDATE_CLIENT_REQUEST: 'UPDATE_CLIENT_REQUEST',
  UPDATE_CLIENT_SUCCESS: 'UPDATE_CLIENT_SUCCESS',
  UPDATE_CLIENT_ERROR: 'UPDATE_CLIENT_ERROR',

  DELETE_CLIENT_REQUEST: 'DELETE_CLIENT_REQUEST',
  DELETE_CLIENT_SUCCESS: 'DELETE_CLIENT_SUCCESS',
  DELETE_CLIENT_ERROR: 'DELETE_CLIENT_ERROR',

  GET_COMPANY_CLIENT_ITEM_REQUEST: 'GET_COMPANY_CLIENT_ITEM_REQUEST',
  GET_COMPANY_CLIENT_ITEM_SUCCESS: 'GET_COMPANY_CLIENT_ITEM_SUCCESS',
  GET_COMPANY_CLIENT_ITEM_ERROR: 'GET_COMPANY_CLIENT_ITEM_ERROR',

  GET_CLIENT_ACTIVE_REQUEST: 'GET_CLIENT_ACTIVE_REQUEST',
  GET_CLIENT_ACTIVE_SUCCESS: 'GET_CLIENT_ACTIVE_SUCCESS',
  GET_CLIENT_ACTIVE_ERROR: 'GET_CLIENT_ACTIVE_ERROR',

  UPDATE_CLIENT_QUERY_PARAMS: 'UPDATE_CLIENT_QUERY_PARAMS'
};
export default ClientTypes;
